import React, { useContext } from 'react';
import { ContextUser } from '../../../providers/ContextUser';
import OrgImage from '../../org-image';
import Navigation from '../navigation';
import { Container, LogoOrgBox } from './styles';
import { Separator } from '../navigation/styles';

const SideBar = ({ isCollapsed, toggleSidebar }) => {
  const ctxUser = useContext(ContextUser);

  return (
    <Container id='sidebar' className={isCollapsed ? 'collapsed' : ''}>
      {ctxUser.currentOrganization && (
        <LogoOrgBox id='logo-org' isCollapsed={isCollapsed}>
          <OrgImage
            id='logo-org-img'
            src={ctxUser.currentOrganization.imageUrl}
            alt='Logo Prefeitura'
          />
        </LogoOrgBox>
      )}
      <Separator />
      <Navigation id='navigation' isCollapsed={isCollapsed} toggleSidebar={toggleSidebar}/>
    </Container>
  );
};

export default SideBar;
